<template>
    <div class="payApvlDialog">

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <el-form-item :label="$t('payApvlSet.processName'/**流程名称*/)" prop="name" style="width: 50%">
                <el-input v-model="ruleForm.name" :placeholder="$t('payApvlSet.inputPlaceholder'/**请输入*/)" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$t('payApvlSet.approvalLevel'/**审批层级*/)" prop="roles">
                <el-tag
                    v-for="(role, index) in ruleForm.roles"
                    :key="role"
                    :disable-transitions="true"
                    @click="handleRoleTagOpen(role, index)"
                    @close="handleRoleTagClose(role)"
                    closable>
                    {{role.roleName}}
                </el-tag>
                <span class="wrapper-new-tag" @click="drawer = true">
                    <i class="el-icon-circle-plus-outline"></i>
                </span>
            </el-form-item>
            <el-form-item :label="$t('payApvlSet.default'/**是否默认*/)" prop="isDefault" style="width: 50%" v-if="isEdit">
                <el-radio
                    v-for="item in defaultOptions"
                    :key="item.codeitemid"
                    :label="item.codeitemid"
                    v-model="ruleForm.isDefault"
                >{{item.codeitemname}}</el-radio>
            </el-form-item>
        </el-form>

        <!-- el-drawer 选择审批角色 -->
        <el-drawer
            style="position:absolute"
            :visible.sync="drawer"
            :with-header="false"
            :wrapperClosable="false"
            :modal="false"
            size="100%"
            direction="rtl">
            <process-role-table ref="refProRoleTable">
                <template v-slot:saveButton="{row}">
                    <el-button @click="handleDrawerRoleSave(row)">{{$t('payApvlSet.save'/**保存*/)}}</el-button>
                </template>
                <template v-slot:cancelButton>
                    <el-button @click="handleDrawerRoleCancel">{{$t('payApvlSet.cancel'/**取消*/)}}</el-button>
                </template>
            </process-role-table>
        </el-drawer>

        <!-- footer el-button -->
        <footer class="center footer-warpper">
            <slot name="submitButton" :postSaveFn="postPayApvlSaveProcess"></slot>
            <el-button @click="resetForm('ruleForm')">{{$t('payApvlSet.cancel'/**取消*/)}}</el-button>
        </footer>

    </div>
</template>

<script>
/**
 * API
 * - postPayApvlSaveProcess     新增 编辑保存
 * - getPayApvlEdit             编辑 回显
 * - postPayApvlCodeList        下拉列表
 */
import { postPayApvlSaveProcess, getPayApvlEdit, postPayApvlCodeList } from '@/api/wage/paymentApproval'

import processRoleTable from './process-role-table'

export default {
    name: 'payApvlDialog',

    components: { processRoleTable },

    data() {
        const rules = Object.freeze()

        return {
            /** el-form */
            ruleForm: {
                name: '',           // 流程名称
                roles: [],          // 审批层级
                proId: '',          // 流程id (新增不填)
                isDefault: '',      // 是否默认流程 (新增不填)
            },
            defaultOptions: [],     // 默认选项

            isEdit: false,          // 是不是编辑
            roleTagIdx: -1,         // 点击 el-tag 时 下标

            /** el-drawer */
            drawer: false,
        }
    },

    computed: {
        rules() {
            let publicRules = {
                name: [ { required: true, message: this.$t('payApvlSet.emptyTips'/** 此项不能为空 */), trigger: 'blur' } ],
                roles: [ { required: true, message: this.$t('payApvlSet.emptyTips'/** 此项不能为空 */) } ],
            }

            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields()
            })
            if (this.isEdit) {
                return {
                    ...publicRules,
                    isDefault: [ { required: true, message: this.$t('payApvlSet.emptyTips'/** 此项不能为空 */) } ]
                }
            } else {
                return publicRules
            }
        }
    },

    mounted() {
        // 编辑时用到
        this.postPayApvlCodeList()
    },

    methods: {
        /** el-from */
        /**
         * @description 删除审批层级
         */
        handleRoleTagClose(role) {
            let roles = this.ruleForm.roles
            roles.splice(roles.indexOf(role), 1)
        },

        /**
         * @description 点击角色打开dialog
         */
        handleRoleTagOpen(role, index) {
            this.roleTagIdx = index
            this.drawer = true
            // !ref 子组件方法
            this.$nextTick(() => {
                this.$refs.refProRoleTable.open(role.id)
            })

        },

        /** el-drawer */
        /**
         * @description slot button 审批角色保存
         */
        handleDrawerRoleSave(row) {
            if (!!row && row.length == 0) {
                this.$message.warning(this.$t('payApvlSet.roleWarnTips'))
                return
            }

            // 判断 新增 or 替换
            if (this.roleTagIdx == -1) {
                this.ruleForm.roles.push({...row[0]})
            } else {
                this.ruleForm.roles.splice(this.roleTagIdx, 1, {...row[0]})
                this.roleTagIdx = -1
            }

            this.handleDrawerRoleCancel()
        },

        /**
         * @description slot button 取消
         */
        handleDrawerRoleCancel() {
            // !ref 子组件方法
            this.$refs.refProRoleTable.clear()
            this.drawer = false
        },


        /** footer el-button */
        /**
         * ! 父组件调用 方法
         * @description 效验 API保存
         */
        postPayApvlSaveProcess(orgId) {
            if (!this.checkSubmitForm()) return new Promise(resolve => resolve(false))

            let ruleForm = this.ruleForm
            const { name: proName, proId, isDefault } = ruleForm

            // ? 新增时保存的是id; 编辑时保存的apprPerId, 如果没有apprPerId 保存id;
            let defApprLevel = ruleForm.roles.map(item => { return { roleId: this.isEdit ? !!item.apprPerId ? item.apprPerId : item.id : item.id, apprType: '92240002' } })
            let params = JSON.stringify({
                // conditionList: '',  // 预留字段
                id: proId,             // 流程id (新增不填)
                isDefault,             // 是否默认流程 (新增不填)
                type: '3',             // 3 付款通知
                proName,               // 流程名称
                defApprLevel,          // 角色集合
                orgId,                 // 组织机构id
            })
            return postPayApvlSaveProcess(params).then(res => {
                let data = res.data
                if (data.code === 0) {
                    this.$message.success(this.$t('payApvlSet.roleSuccessTips'/**保存成功*/))
                    this.resetForm()
                    return true
                }
            })
        },

        checkSubmitForm() {
            let result = false
            this.$refs.ruleForm.validate(valid => {
                result = valid ? true : false
            })
            return result
        },

        /**
         * @description 取消
         */
        resetForm() {
            this.isEdit = false
            this.ruleForm.proId = ''
            this.ruleForm.isDefault = ''

            this.$refs.ruleForm.resetFields()
            this.drawer && this.handleDrawerRoleCancel()

            // ! 关闭父组件 dialog 新增编辑 弹窗变量
            this.$parent.$parent.dialogVisible = false
        },


        /** is edit 是编辑 */
        /**
         * @description API 是否默认 选项
         */
        postPayApvlCodeList() {
            let params = { codeSetId: '0090' }
            postPayApvlCodeList(params).then(res => {
                let data = res.data.data
                if (!data || data.lenght === 0) return
                this.defaultOptions = Object.freeze(data)
            })
        },

        /**
         * ! 父组件调用 方法
         * @description API 编辑回显
         */
        getPayApvlEdit(row) {
            this.isEdit = true
            this.ruleForm.proId = row.id
            getPayApvlEdit({
                type: '3',
                rid: row.id,
                orgId: row.orgId
            }).then(res => {
                let data = res.data.data
                if (!!data && res.data.msg === 'success') {
                    this.ruleForm.name = data.process.proName
                    this.ruleForm.roles = data.process.defApprLevel
                    this.ruleForm.isDefault = data.process.isDefault
                }
            })
        },

    },
}
</script>

<style lang="scss">
.payApvlDialog {
    position:relative;
    overflow: hidden;
    height: 500px;
    outline: none;
    .footer-warpper {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }
}
.payApvlDialog .el-drawer__container { outline: none; }
.payApvlDialog .el-tag { cursor: pointer; }
.payApvlDialog .el-tag + .el-tag { margin-left: 10px; }

.payApvlDialog .wrapper-new-tag {
    display: inline-block;
    font-size: 22px;
    height: 32px;
    line-height: 32px;
    margin-left: 10px;
    vertical-align: bottom;
    cursor: pointer;
    &:hover {
        color: #5cb6ff;
    }
}
</style>
